import React, { useRef } from 'react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { AgGridReact } from 'ag-grid-react';
import { mergeGridOpts } from 'utils/agGrid/options';
import useColDefs from './useColDefs';
import useDatasource from './useDatasource';
import clearingAccountsOpts from '../options';
import useOnCellClick from '../useOnCellClick';
import useContext from '../useClearingAccountsContext';

const opts = mergeGridOpts(clearingAccountsOpts, {
  blockLoadDebounceMillis: 1500,
});

export const MEMBER_CLEARING_ACCOUNTS_GRID_NAME = 'memberClearingAccounts';
const MEMBER_CLEARING_ACCOUNTS_GRID_VERSION = 1;

const MemberClearingAccountsGrid = () => {
  const gridRef = useRef<AgGridReact>(null);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName: MEMBER_CLEARING_ACCOUNTS_GRID_NAME,
    version: MEMBER_CLEARING_ACCOUNTS_GRID_VERSION,
  });

  const onCellClicked = useOnCellClick();
  const context = useContext();
  const columnDefs = useColDefs();
  const datasource = useDatasource();

  return (
    <div className="ag-theme-quartz">
      {gridVisible ? (
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          gridOptions={opts}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          rowModelType="serverSide"
          serverSideDatasource={datasource}
          context={context}
          onCellClicked={onCellClicked}
        />
      ) : null}
    </div>
  );
};

export default MemberClearingAccountsGrid;
